<template>
    <nav id="nav" v-if="showNavi">
        <div class="nav-wrapper">
            <a href="#" class="show-mobile-navigation" id="mobile-navigation" v-on:click.prevent="openNavigation">Aktuell</a>
            <router-link id="i_1_0" to="/" exact-active-class="is-active" v-on:click.native="closeNavigation" v-on:focus="scrollToTop">Aktuell</router-link>
            <router-link id="i_1_1" to="/bahnnostalgie" exact-active-class="is-active" v-on:click.native="closeNavigation" v-on:focus="scrollToTop">Bahnnostalgie</router-link>
            <router-link id="i_1_2" to="/bahntechnik" exact-active-class="is-active" v-on:click.native="closeNavigation" v-on:focus="scrollToTop">Bahntechnik</router-link>
            <router-link id="i_1_3" to="/bahnziele" exact-active-class="is-active" v-on:click.native="closeNavigation" v-on:focus="scrollToTop">Bahnziele</router-link>
            <router-link id="i_1_4" to="/modelleisenbahn" exact-active-class="is-active" v-on:click.native="closeNavigation" v-on:focus="scrollToTop">Modelleisenbahn</router-link>
            <router-link id="i_1_5" to="/info" exact-active-class="is-active" v-on:click.native="closeNavigation" v-on:focus="scrollToTop">Über</router-link>
        </div>
    </nav>
</template>

<script>

    export default {
        computed: {
          showNavi() {
             let show = true;
             if (this.$route.name === 'player') {
                show = false;
             }
             return show;
          }
        },
        methods: {
            openNavigation(event) {
                document.getElementById('nav').classList.add('open');

            },
            closeNavigation(event) {
                document.getElementById('mobile-navigation').innerText = event.target.innerText;
                document.getElementById('nav').classList.remove('open');
            },
            scrollToTop(event) {
                window.scrollTo(0, 0);
                document.getElementsByClassName('page')[0].scrollTo(0,0);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// Navigation.vue?7776fec8